import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import SEOHead from "@/components/SEOHead";
import { blogPosts } from "@/data/blogPosts";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";

const Blog = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <SEOHead
        title="Blog - Guías de Compresión y Optimización de Imágenes | CompresorJPEG"
        description="Aprende a comprimir y optimizar imágenes para web, redes sociales y SEO. Guías prácticas sobre formatos JPG, PNG, WebP y Core Web Vitals."
        keywords="blog comprimir imagenes, guias optimizacion imagenes, tutorial compresion fotos, seo imagenes"
        canonical="https://compresorjpeg.com/blog"
      />
      <NavBar />

      <header className="text-center py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Blog: Guías de Optimización de Imágenes
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Aprende las mejores técnicas para <strong>comprimir</strong>, <strong>optimizar</strong> y gestionar imágenes para web, redes sociales y SEO.
          </p>
        </div>
      </header>

      <main className="container mx-auto px-4 pb-16">
        <div className="max-w-4xl mx-auto grid gap-6">
          {blogPosts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`}>
              <Card className="p-6 hover:shadow-lg transition-shadow duration-300 bg-white/80 backdrop-blur-sm">
                <article>
                  <h2 className="text-xl font-semibold text-gray-800 mb-2 group-hover:text-blue-600">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 mb-4">{post.description}</p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center gap-4">
                      <span className="flex items-center gap-1">
                        <Calendar className="h-4 w-4" />
                        {new Date(post.date).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock className="h-4 w-4" />
                        {post.readTime} de lectura
                      </span>
                    </div>
                    <span className="flex items-center gap-1 text-blue-600 font-medium">
                      Leer más <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </article>
              </Card>
            </Link>
          ))}
        </div>

        <section className="max-w-4xl mx-auto mt-16 text-center p-8 bg-white/60 rounded-2xl">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">¿Necesitas comprimir imágenes ahora?</h2>
          <p className="text-gray-600 mb-6">Usa nuestra herramienta gratuita para comprimir JPG, PNG y WebP al instante.</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            Ir al Compresor <ArrowRight className="h-4 w-4" />
          </Link>
        </section>
      </main>
    </div>
  );
};

export default Blog;
